import { inject, observer } from "mobx-react";
import * as React from 'react';
import { Button, Col, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import FormGroup from "reactstrap/lib/FormGroup";
import ButtonRow from 'src/Components/ButtonRow';
import DataTable from 'src/Components/DataTable';
import EInput, { EButton } from 'src/Components/EInput';
import { TaxRate } from 'src/Interfaces/AdminInterface';
import { AdminStore } from 'src/Stores/Admin/AdminStore';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { UserStore } from 'src/Stores/User/UserStore';
import DeepCopy from "src/UtilityFunctions/DeepCopy";

@inject('stores')
@observer
export class AdminTaxRates extends React.Component {
    public props: any;
    private AdminStore: AdminStore;
    private UserStore: UserStore;
    private MessageStore: MessageStore;
    private adminTaxRateHeader = [
        "Tax Rate",
        "Description",
    ];

    public state = {
        editing: false,
        rowIndex: 0,
        taxRate: new TaxRate(),
        taxRateModal: false,
        taxRates: [] as TaxRate[],
    };

    constructor(props: any) {
        super(props);
        this.AdminStore = props.stores.AdminStore;
        this.UserStore = props.stores.UserStore;
        this.MessageStore = props.stores.MessageStore;
    }

    public componentDidMount() {
        this.AdminStore.getTaxRates().
            then(taxRates => {
                this.setState({taxRates});
            });

        if (!this.UserStore.user) {
            this.UserStore.getProfile();
        }
    }

    private formatTaxRatesData = () => {
        const adminTaxRates = this.state.taxRates;
        const rows = [] as any[];
        adminTaxRates.forEach(taxRate => {
            const tempRow = [
                {
                    content: taxRate.rate + '%'
                },
                {
                    content: taxRate.description,
                }
            ];
            rows.push(tempRow);
        });
        return { headers: this.adminTaxRateHeader, rows };
    }

    private addTaxRate = (addAnother: boolean) => () => {
        const { taxRate, taxRates, editing, rowIndex } = this.state;
        if (editing) {
            taxRates[rowIndex] = taxRate;
        } else {
            taxRates.push(taxRate);
        }
        if (addAnother) {
            this.setState({taxRate: new TaxRate(), taxRates});
        } else {
            this.setState({editing: false, taxRate: new TaxRate(), taxRateModal: false, taxRates});
        }
    }

    public onEditTaxRate = (index: number) => {
        this.setState({editing: true, rowIndex: index, taxRate: DeepCopy(this.state.taxRates[index]), taxRateModal: true});
    }

    public toggleTaxRate = () => {
        this.setState({taxRateModal: !this.state.taxRateModal, taxRate: new TaxRate()});
    }

    public onDeleteTaxRate = (index: number) => {
        const taxRates = this.state.taxRates;
        taxRates.splice(index, 1);
        this.setState({taxRates});
    }

    private handleTaxRateChange = (event: any) => {
        const taxRate = this.state.taxRate;
        taxRate[event.target.name] = event.target.value;
        this.setState({taxRate});
    }

    private saveTaxRates = () => {
        this.AdminStore.postTaxRates(this.state.taxRates)
            .then(data => {
                this.MessageStore.addMessage('Tax Rate List Saved.', 'success');
            });
    }

    public render() {
        return(
            <div>
                <Row className="header">
                    <Col md="6">
                        <h1 className="float-left">Tax Rates</h1>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                        <DataTable 
                            list={this.formatTaxRatesData()}
                            onNew={this.UserStore.hasPermission('Permissions.Admin.TaxRates.Create') ? {
                                callback: this.toggleTaxRate,
                                text: 'Add New Tax Rate'
                            } : undefined}
                            onEdit={this.UserStore.hasPermission('Permissions.Admin.TaxRates.Update') ? this.onEditTaxRate : undefined}
                            onDelete={this.UserStore.hasPermission('Permissions.Admin.TaxRates.Delete') ? this.onDeleteTaxRate : undefined}
                        />
                    </Col>
                </Row>
                {
                    ( this.UserStore.hasPermission('Permissions.Admin.TaxRates.Create')
                    || this.UserStore.hasPermission('Permissions.Admin.TaxRates.Update')
                    || this.UserStore.hasPermission('Permissions.Admin.TaxRates.Delete')
                    )
                    &&
                    <ButtonRow>
                        <Button color="primary" onClick={this.saveTaxRates}>Save Tax Rates List</Button>
                    </ButtonRow>
                }
                <Modal isOpen={this.state.taxRateModal} toggle={this.toggleTaxRate} backdrop="static">
                    <ModalHeader toggle={this.toggleTaxRate}>
                        Add/Edit Tax Rate
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                            <FormGroup className="required">
                                <Label>Tax Rate</Label>
                                <EInput
                                    name="rate"
                                    id="rate"
                                    value={this.state.taxRate.rate}
                                    onChange={this.handleTaxRateChange}
                                    data-validation="decimal"
                                    required={true}
                                />
                            </FormGroup>
                            <FormGroup className="required">
                                <Label>Description</Label>
                                <EInput
                                    name="description"
                                    id="description"
                                    required={true}
                                    value={this.state.taxRate.description}
                                    onChange={this.handleTaxRateChange}
                                />
                            </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleTaxRate}>Cancel</Button>
                        <EButton color="primary" onClick={this.addTaxRate(false)}>Save</EButton>
                        <EButton color="primary" onClick={this.addTaxRate(true)}>Add Another</EButton>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default AdminTaxRates;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/TaxRates/AdminTaxRates.tsx